/* Cart Drawer — Recommendations Slider (nav only, Liquid-driven filtering) */
(() => {
  const FLAG = 'smRecoInit';

  function bindNav(root) {
    const wrapper = root.querySelector('.sm-cart-reco__track-wrapper');
    const list    = root.querySelector('.sm-cart-reco__list');
    const prev    = root.querySelector('.sm-cart-reco__nav--prev');
    const next    = root.querySelector('.sm-cart-reco__nav--next');

    if (!wrapper || !list || !prev || !next) return;

    const getStep = () => {
      const item = list.querySelector('.sm-cart-reco__item');
      return item ? item.offsetWidth + 8 : 220;
    };

    const updateNavState = () => {
      const maxScroll = wrapper.scrollWidth - wrapper.clientWidth - 1;
      prev.disabled = wrapper.scrollLeft <= 0;
      next.disabled = wrapper.scrollLeft >= maxScroll;
    };

    const scrollByDir = (dir) => {
      const step = getStep();
      wrapper.scrollBy({ left: dir * step, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByDir(-1));
    next.addEventListener('click', () => scrollByDir(1));
    wrapper.addEventListener('scroll', updateNavState);

    updateNavState();
  }

  function initOne(section) {
    if (!section) return;
    if (section.dataset[FLAG] === '1') return;

    const root = section.querySelector('[data-sm-cart-reco]');
    if (!root) return;

    section.dataset[FLAG] = '1';
    bindNav(root);
  }

  function initAll() {
    document
      .querySelectorAll('#CartDrawerReco')
      .forEach((section) => initOne(section));
  }

  function observeDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const mo = new MutationObserver(() => {
      initAll();
    });

    mo.observe(drawer, { childList: true, subtree: true });
  }

  function boot() {
    initAll();
    observeDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
